import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from '@storable/canaveral-components';
import HostnameCertSettingsStatusPanelUploadModal from '../../containers/HostnameCertSettingsStatusPanelUploadModal';
import styles from './styles.scss';

const propTypes = {
  hostname: PropTypes.shape({
    id: PropTypes.string,
    certificate: PropTypes.object,
  }).isRequired,
};

const defaultProps = {};

const HostnameCertSettingsStatusPanelUpload = ({ hostname }) => {
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <Col className={styles.container}>
      <p>
        If you need to temporarily upload an SSL Certificate and/or a private key file from an
        external provider (i.e. GoDaddy) to prevent expiration, you may do so below.
      </p>
      <Button
        className={styles.button}
        context="neutral"
        onClick={toggleModal}
      >
        Manage External Certificate
      </Button>
      {showModal && (
        <HostnameCertSettingsStatusPanelUploadModal
          hostnameId={hostname.id}
          onClose={toggleModal}
        />
      )}
    </Col>
  );
};

HostnameCertSettingsStatusPanelUpload.propTypes = propTypes;
HostnameCertSettingsStatusPanelUpload.defaultProps = defaultProps;

export default HostnameCertSettingsStatusPanelUpload;
